/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerLeftUpIcon16Regular = forwardRef('ArrowDCornerLeftUpIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1.97 6.22a.75.75 0 0 0 1.06 1.06l3.22-3.22V12A2.75 2.75 0 0 0 9 14.75h6.25a.75.75 0 0 0 0-1.5H9c-.69 0-1.25-.56-1.25-1.25V4.06l3.22 3.22a.75.75 0 1 0 1.06-1.06L8.38 2.568a1.95 1.95 0 0 0-2.758 0L1.97 6.22Z" })));
});
